import { AxiosRequestConfigMethods } from "@/api/types";
import { brandUrl, fetchFromBrandedUrl } from "@/api/utils";
import { EnvironmentVariables } from "@/modules/common/types";
import { AxiosResponse } from "axios";
import { Project } from "../../dtos/construction-management";

export async function getConstructionProjectDetails(propertyUid: string) {
  const apiUrl = brandUrl(
    `${EnvironmentVariables.CONSTRUCTION_API_URL}/projects/by-property/${propertyUid}`,
  );

  return fetchFromBrandedUrl({
    options: {
      brandedUrl: apiUrl,
      isEncoded: false,
      method: AxiosRequestConfigMethods.GET,
      responseType: "json",
    },
  }) as Promise<AxiosResponse<Project>>;
}
